import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'id',
        label: i18n.t('attributes.id'),
        _style: 'width:5%'
    },
    {
        key: 'name',
        label: i18n.t('media.name'),
        _style: 'width:15%'
    },
    {
        key: 'type',
        label: i18n.t('media.type'),
        _classes: 'text-center',
    },
    {
        key: 'status',
        label: i18n.t('media.status'),
        _classes: 'text-center align-middle',
    },
    {
        key: 'level',
        label: i18n.t('media.level'),
        _classes: 'text-center align-middle',
    },
    {
        key: 'rejection_reason',
        label: i18n.t('media.media_rejection_reason'),
        _classes: 'text-center align-middle',
    },
    {
        key: 'createdAt',
        label: i18n.t('attributes.created_at'),
        _classes: 'ltr'
    },
    {
        key: 'user',
        label: i18n.t('publisher._'),
    },
    {
        key: 'actions',
        label: i18n.t('attributes.actions'),
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('media.level')}),
        value: {
            direction: 'desc',
            column: 'level'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('media.level')}),
        value: {
            direction: 'asc',
            column: 'level'
        }
    },
]